import { Title } from "../../../common/styles";
import img from "./image.png";
import {
    Img,
    ListBlock,
    ListElement,
    Section,
    TextBlock,
    Text
} from "./styled";

const AboutPaste = () => {
    return (
        <Section>
            <Img src={img} alt="Sugaring paste" />
            <TextBlock>
                <Title>Що ж таке шугаринг?!</Title>
                <Text>
                    Шугаринг - це спосіб депіляції з використанням цукрової пасти.
                    Схожа на карамель паста видаляє волосся разом з коренем та забирає ороговілі частинки шкіри 😊
                </Text>
                <ListBlock>
                    <ListElement>
                        Шугаринг -це маленька SPA процедура для Вашого тіла.
                    </ListElement>
                    <ListElement>
                        Шугаринг вважається одним з найефективніших методів депіляції.
                    </ListElement>
                    <ListElement>
                        Шугаринг підходить для всіх частин тіла та для всіх типів волосся.
                    </ListElement>
                    <ListElement>
                        Шугаринг не провокує почервоніння шкіри, запалення фолікулів та появу врослого волосся.
                    </ListElement>
                </ListBlock>
            </TextBlock>
        </Section>
    );
};

export default AboutPaste;